import { observer } from 'mobx-react-lite'
import { useEffect } from 'react'
import { type IParamsGetCallHistoryStatistic } from 'entities/CallHistory/api/types'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { CallHistoryFiltersList } from 'pages/conversations/pages/calls/ui/CallHistoryFilters/ui/CallHistoryFiltersList/CallHistoryFiltersList'
import { CallHistoryFiltersDropdown } from 'pages/conversations/pages/calls/ui/CallHistoryFilters/ui/CallHistoryFiltersDropdown/CallHistoryFiltersDropdown'
import { type CallHistoryStore } from 'pages/conversations/pages/calls/ui/CallHistory'

type ICallHistoryFiltersProps = {
  store: CallHistoryStore
  variant?: 'list' | 'dropdown'
}

export const CallHistoryFilters = observer(
  ({ store, variant = 'list' }: ICallHistoryFiltersProps) => {
    const { callHistoryFiltersStore, filtersStore } = store
    const { loadData } = callHistoryFiltersStore
    const { inboxesStore } = useEntitiesContext()

    const params: IParamsGetCallHistoryStatistic = {
      team_id: inboxesStore.currentInboxTypeId,
      team_type: inboxesStore.currentInboxType || 3,
      group:
        filtersStore.filter && filtersStore.filter?.key !== 'all' ? filtersStore.filter?.key : null,
    }

    useEffect(() => {
      return () => {
        store.dispose()
      }
    }, [])

    useEffect(() => {
      loadData(params)
      store.loadCallHistory()
    }, [inboxesStore.currentInboxTypeId, filtersStore.filter?.key])

    if (variant === 'list') {
      return <CallHistoryFiltersList store={callHistoryFiltersStore} />
    }
    if (variant === 'dropdown') {
      return <CallHistoryFiltersDropdown store={callHistoryFiltersStore} />
    }
    return null
  }
)
